<mat-card>
  <div class="container" style="background-color: #f5f7fa">
    <div class="sticky-0">
      <h5 class="fw-400">Home First</h5>
      <h6 class="badge badge-success badge-users">
        <span class="ft-users"></span> {{ totalPlayers }}
      </h6>
      <div></div>
    </div>
    @if (
      name === 'Code of Conduct' ||
      name === 'Posh' ||
      name === 'Health and Safety'
      ) {
      <div
        class="search-holder"
        >
        <form [formGroup]="searchForm" class="example-form">
          <mat-form-field
            class="example-full-width"
            style="float: right"
            appearance="outline"
            >
            <mat-label>Search</mat-label>
            <input
              type="search"
              matInput
              formControlName="searchCtrl"
              #message
              maxlength="25"
              placeholder="Search"
              />
            </mat-form-field>
          </form>
        </div>
      }
      <button
        type="button"
        class="btn btn-raised btn-success btn-sm btn-action mlr-2"
        style="margin-left: 5px"
        (click)="downloadReport()"
        >
        <span class="fa fa-download"></span> Download
      </button>
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            @if (
              name === 'Code of Conduct' ||
              name === 'Posh' ||
              name === 'Health and Safety'
              ) {
              <th width="25%">Name</th>
              <!-- <th>Last Name</th> -->
              <th width="40%">Email</th>
              <th width="30%">Played On</th>
              <th width="5%">Score</th>
            }

            @if (name === 'Insider Trading' || name === 'IT Security') {
              <!-- <th>Last Name</th> -->
              <th width="30%">Email</th>
              <th width="30%">Status</th>
              <th width="20%">Score</th>
            }
            <!-- <ng-container *ngIf="name === 'IT Security'">

            <th width="30%">Name</th>
            <th width="30%">Status</th>
            <th width="20%">Score</th>
          </ng-container> -->
          <!-- <th>Company</th>
          <th>Division</th> -->
          <!-- <th>Login Count</th> -->
          <!-- <th>Actions</th> -->
        </tr>
      </thead>
      <tbody>
        @if (players && players.length <= 0) {
          <tr>
            <td></td>
            <td>NO DATA FOUND</td>
          </tr>
        }
        @for (player of players; track player; let i = $index) {
          <tr
            style="cursor: pointer"
            >
            <td>
              <strong>{{ i + 1 }}</strong>
            </td>
            @if (
              name === 'Code of Conduct' ||
              name === 'Posh' ||
              name === 'Health and Safety'
              ) {
              <td>
                <strong>{{ player?.name }}</strong>
              </td>
              <!-- <td><strong>{{ player?.lastName || 'NA' }}</strong></td> -->
              <td>
                <strong>{{ player.email }}</strong>
              </td>
              <td>
                <strong>{{ player.createdAt | date: 'd MMM, y' }}</strong>
              </td>
              @if (name === 'Code of Conduct') {
                <td>
                  @if (player?.highestScore === 0) {
                    <strong>NA</strong>
                  }
                  @if (player?.highestScore !== 0) {
                    <strong>{{
                      player?.highestScore
                    }}</strong>
                  }
                </td>
              }
              @if (name === 'Posh' || name === 'Health and Safety') {
                <td>
                  @if (player?.score) {
                    <strong>{{ player?.score }}</strong>
                  }
                </td>
              }
            }
            @if (name === 'Insider Trading' || name === 'IT Security') {
              <td>
                <strong>{{ player.email }}</strong>
              </td>
              <td>
                <strong>{{ player.status }}</strong>
              </td>
              <td>
                @if (player?.score) {
                  <strong>{{ player?.score }}</strong>
                }
              </td>
            }
            <!-- <ng-container *ngIf="name === 'IT Security'">
            <td>
              <strong>{{ player.name }}</strong>
            </td>
            <td>
              <strong>{{ player.status }}</strong>
            </td>
            <td>
              <strong *ngIf="player?.score">{{ player?.score }}</strong>
            </td>
          </ng-container> -->
        </tr>
      }
    </tbody>
  </table>
</div>
</mat-card>
